import { render, staticRenderFns } from "./MasterMenu.vue?vue&type=template&id=3a2bbc90&"
import script from "./MasterMenu.vue?vue&type=script&lang=js&"
export * from "./MasterMenu.vue?vue&type=script&lang=js&"
import style0 from "./MasterMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports